<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.component("v-select", vSelect);

export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      arrayDepartamentos: [],
      departamentoId: "",
      formPro: {
        direccionp: "",
        observaciones: "",
        fecha_productos: new Date(),
        state: true,
        id: 0,
      },
      detalleprodutos: [],
      title: "Productos bajos en existencia",
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }

    this.detalle();
    this.departamentos();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    showDate2(date) {
      return moment(date).locale("es").format("MMM Do YYYY");
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    departamentos() {
      axios
        .get(process.env.VUE_APP_URL + "departamentos/get-departamentos", {
          headers: { "x-token": this.userT.token },
        })
        .then((response) => {
          this.arrayDepartamentos = response.data.departamento;
        });
    },
    detalle() {
      console.log(this.departamentoId.id);
      axios
        .get(
          process.env.VUE_APP_URL +
            "reportes/reporte_stock?departamento=" +
            this.departamentoId.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detalleprodutos = response.data.rows;
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-lg-9">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6">
            <div class="mt-2">
              <h5></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <img
                  class="img-fluid float-right grises"
                  src="../../../../src/assets/images/logoZonaR.png"
                  alt="Logo"
                />
              </div>
              <div class="col-md-4"></div>
            </div>
            <br />
            <div class="row">
              <h2 id="visor_imagenes">
                <span>Productos bajos en existencia</span>
              </h2>
              <div class="row">
                <div class="col-10">
                  <v-select
                    v-model.trim="departamentoId"
                    :options="arrayDepartamentos"
                    @input="detalle"
                    placeholder="Buscar departamento"
                    label="nombre_estante"
                  >
                    <template v-slot:option="options">
                      {{ options.nombre_estante }}
                    </template>
                    <template v-slot:selected-option="option">
                      {{ option.nombre_estante }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="d-print-none">
                <div class="float-end">
                  <a
                    href="javascript:window.print()"
                    class="btn btn-primary w-md waves-effect waves-light me-1"
                    ><i class="fa fa-print"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Departamento</th>
                    <th>Pasillo</th>
                    <th>Ubicación</th>
                    <th>Proveedor</th>
                    <th>Teléfono</th>
                    <th>Producto y presentacion</th>
                    <th>Existencia</th>
                    <th>Precio venta</th>
                    <th>Precio compra</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in this.detalleprodutos"
                    v-bind:key="idx"
                  >
                    <td>
                      {{
                        item.estante
                          ? item.estante.nombre_estante
                          : "sin departamento"
                      }}
                    </td>
                    <td>
                      {{
                        item.estante
                          ? item.estante.nombre_pasillo
                          : "sin pasillo"
                      }}
                    </td>
                    <td v-if="item.departamento">
                      {{ item.departamento.nombre_departamento }}
                    </td>
                    <td>{{ item.Stock.proveedore.company_proveedor }}</td>
                    <td>{{ item.Stock.proveedore.telefono_proveedor }}</td>
                    <td>
                      {{ item.Stock.producto.nombre_producto }}
                      {{ item.Stock.presentacione.nombre_presentacion }}
                    </td>
                    <td>{{ item.Stock.existencia_stock }}</td>
                    <td>{{ money(item.Stock.precio_venta_stock) }}</td>
                    <td>{{ money(item.Stock.precio_compra_stock) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6"></div>
              <!-- end col -->

              <!-- end col -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.grises {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}
</style>
